import { KeyboardArrowDown } from "@mui/icons-material";
import type { SelectChangeEvent } from "@mui/material";
import { MenuItem, Select } from "@mui/material";
import { useState } from "react";

import type { IStatusRule } from "../StatusChip";
import StatusChip from "../StatusChip";
import styles from "./style.module.scss";

interface IStatusChipSelector {
    /**
     * Status of the selected chip.
     */
    status: any;
    /**
     * Rules to display the chip (text and colour)
     */
    statusRules: Record<any, IStatusRule>;
    /**
     * Action to trigger when chip changed.
     */
    onChange: (status: number) => void;
    /**
     * With of the selector. Should be size of largest chip option.
     */
    width: string;
    /**
     * Values where statusValue not automatically changed -> for instance, a modal is opened to confirm the change.
     */
    blockValues?: any[];
}

/**
 * Selector with list of chips to choose from. Linked to StatusChip component.
 */
const StatusChipSelector = ({ status, statusRules, onChange, width, blockValues = [] }: IStatusChipSelector) => {
    const [statusValue, setStatusValue] = useState(status);

    const handleChange = async (event: SelectChangeEvent) => {
        if (!blockValues.includes(+event.target.value)) {
            await setStatusValue(event.target.value);
        }
        onChange(+event.target.value);
    };

    return (
        <>
            <Select
                value={statusValue}
                onChange={handleChange}
                className={styles["selector-input"]}
                IconComponent={KeyboardArrowDown}
                sx={{
                    backgroundColor: statusRules[statusValue].cssBackgroundColor,
                    "& .MuiSelect-select": { width },
                    "& .MuiSvgIcon-root": {
                        color: statusRules[statusValue].cssIconColor,
                    },
                }}
            >
                {Object.keys(statusRules).map((key) => {
                    return (
                        <MenuItem value={key} key={`chip-${key}`}>
                            <StatusChip status={key} statusRules={statusRules} hideDot />
                        </MenuItem>
                    );
                })}
            </Select>
        </>
    );
};

export default StatusChipSelector;
